import React from "react";
import { DeleteOutlined } from "@ant-design/icons";
import "./GalleryLabelTab.css";

const GalleryLabelTab = ({
  name,
  isSelected,
  isEmpty,
  canDelete,
  onDelete,
}) => {
  const showDelete = Boolean(isSelected && isEmpty && canDelete);

  return (
    <span className="gallery-label-tab">
      <span className="gallery-label-tab-text">{name}</span>
      {showDelete && (
        <button
          type="button"
          className="gallery-label-tab-delete"
          aria-label={`Delete label ${name}`}
          onClick={(e) => {
            e.stopPropagation();
            onDelete?.();
          }}
        >
          <DeleteOutlined />
        </button>
      )}
    </span>
  );
};

export default GalleryLabelTab;
